<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <div v-if="!hasAvailableSessions" class="text-center py-5">
      <div class="riprova-container-malle">
        <h2 class="fw-bold mb-3">Spiacenti</h2>
        <p>LE PRENOTAZIONI PER L'EVENTO SONO CHIUSE PER IL RAGGIUNGIMENTO DELLA CAPIENZA MASSIMA IN TUTTE LE GIORNATE PREVISTE.</p>
      </div>
    </div>

    <form v-else @submit.prevent="handleSubmit(submit)" class="malle-form">

       <p class="text-subtitle" v-html="header?.subtitle "></p>

      <div
        v-for="(row, rIndex) in layout"
        :key="'row-' + rIndex"
        :class="rowClass(row)"
      >
        <div
          v-for="(col, cIndex) in row.columns"
          :key="'col-' + cIndex"
          :class="colClass(col)"
        >
          <template v-for="fieldName in col.fields">
            <DynamicField
              v-if="fieldName !== 'privacy' && getField(fieldName)"
              :key="fieldName"
              :field="getField(fieldName)"
              v-model="form[fieldName]"
              @session-selected="handleExclusiveSession"
            />
          </template>
        </div>
      </div>

      <div v-if="showSessionError" class="errore-malle mt-3">
        Devi scegliere almeno uno slot per continuare
      </div>

      <div v-if="getField('privacy')" class="privacy-container-malle mt-5">
        <DynamicField
          :field="getField('privacy')"
          v-model="form['privacy']"
        />
      </div>

      <div class="text-center mt-5">
        <button type="submit" :disabled="loading" class="btn-malle">
          {{ loading ? 'Invio in corso...' : 'Registrati' }}
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import DynamicField from './DynamicField'

export default {
  name: 'DynamicForm',
  props: ['schema', 'layout', 'loading', 'header'],
  components: { DynamicField },
  data () {
    return { form: {}, showSessionError: false }
  },
  computed: {
    hasAvailableSessions () {
    // 1. Filtra solo i campi che sono di tipo 'session_radio'
      const sessionFields = this.schema?.filter(field => field.type === 'session_radio') || []

      // 2. Se non ci sono proprio campi sessione, decidere se mostrare il form o no.
      // Se il form DEVE avere sessioni per essere valido, restituiamo false se sessionFields è vuoto.
      if (sessionFields.length === 0) return false

      // 3. Controlla se esiste almeno un campo sessione che abbia almeno un'opzione disponibile
      return sessionFields.some(field =>
        field.options && field.options.some(option => option.available === true)
      )
    }
  },
  methods: {
    // Determina se la riga contiene campi sessione
    rowClass (row) {
      const isSessionRow = row.columns.some(col =>
        col.fields.some(f => f.startsWith('sessions_'))
      )
      // Se è una riga di sessioni, usiamo d-flex per affiancarle su desktop
      return isSessionRow
        ? 'row g-3 d-flex flex-nowrap-lg justify-content-center session-group'
        : 'row g-4 justify-content-start'
    },

    // Assegna la larghezza corretta alle colonne
    colClass (col) {
      const fieldName = col.fields[0]
      if (fieldName && fieldName.startsWith('sessions_')) {
        // Forza 3 colonne (lg-4) su schermi grandi, 12 su mobile
        return 'col-12 col-lg-4'
      }
      return `col-12 col-md-${col.width}`
    },

    initialize () {
      const updatedForm = { ...this.form }
      this.schema.forEach(field => {
        if (updatedForm[field.name] === undefined) {
          updatedForm[field.name] = field.type.includes('checkbox') ? [] : (field.name === 'privacy' ? null : '')
        }
      })
      this.form = updatedForm
    },

    handleExclusiveSession ({ fieldName }) {
      this.showSessionError = false
      Object.keys(this.form).forEach(key => {
        if (key.startsWith('sessions_') && key !== fieldName) this.form[key] = ''
      })
    },

    submit () {
      this.showSessionError = false
      const sessionFields = Object.keys(this.form).filter(k => k.startsWith('sessions_'))
      const hasSession = sessionFields.some(k => this.form[k] !== '' && this.form[k] !== null)
      if (!hasSession && sessionFields.length > 0) {
        this.showSessionError = true
        return
      }
      this.$emit('submitted', { ...this.form })
    },

    getField (name) { return this.schema.find(f => f.name === name) }
  },
  watch: {
    schema: { immediate: true, handler () { this.initialize() } }
  }
}
</script>

<style scoped>
.malle-form { max-width: 1200px; margin: 0 auto; padding: 0 15px; }
  .text-subtitle{
text-align: center;
display: block;
    font-size: 1em;
    margin-bottom: 80px;
}

/* Forza l'allineamento orizzontale solo su schermi desktop */
@media (min-width: 992px) {

  .session-group {
    display: flex !important;
    flex-wrap: nowrap !important; /* Impedisce di andare a capo se sono 3 */
  }
  .text-subtitle{
   margin-bottom: 50px!important;
}
}

/* Mobile: i box tornano uno sopra l'altro */
@media (max-width: 991px) {

  .session-group {
    flex-wrap: wrap !important;
  }
  .text-subtitle{
   margin-bottom: 50px!important;
}
}

.btn-malle {
  width: 100%; max-width: 400px; padding: 16px; border: none; border-radius: 50px;
  font-size: 14px; font-weight: bold; color: #fff; background-color: #da291c;
  text-transform: uppercase; letter-spacing: 2px; cursor: pointer;
}
.errore-malle { color: #da291c; font-weight: bold; text-align: center; text-transform: uppercase; margin-bottom: 20px; }
.riprova-container-malle { border: 2px solid #da291c; padding: 40px; border-radius: 20px; text-align: center; }

@media (max-width: 576px) {

  .text-subtitle{
text-align: center;
display: block;
    font-size: 0.8em;
    margin-bottom: 80px;
}

}

</style>
